import React, { useCallback, useMemo } from 'react';
import _ from 'lodash';
import ComponentPropTypes from './ComponentPropTypes';
import RadioGroup from '../../RadioGroup/RadioGroup';

const RadioGroupComponent = ({ model, value, onChange }) => {
  const _onChange = useCallback((newValue) => {
    onChange(model, newValue);
  }, [model, onChange]);
  const radios = useMemo(() =>
    _.map(model.radios, radio => ({ name: model.path, ...radio }))
  , [model.path, model.radios]);

  return (
    <RadioGroup
      radios={radios}
      value={value}
      onValueChanged={_onChange}
      direction={model?.properties?.direction} spaceItems={model?.properties?.spaceItems} />
  );
};

RadioGroupComponent.propTypes = ComponentPropTypes;

export default React.memo(RadioGroupComponent);


